import { Snackbar } from '@mui/material';
import React from 'react';

import { useActions } from '../../hooks/useActions';
import { useLayout } from '../../hooks/useLayout';
import { Icon } from '../Icon';

import './Snackbar.sass';

export const CustomSnackbar = () => {
  const { closeSnackbar } = useActions();
  const { snackbarIsOpen, snackbarTitle } = useLayout();

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }

    closeSnackbar();
  };

  return (
    <Snackbar
      className="snackbar"
      open={snackbarIsOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      sx={{
        position: 'absolute',
      }}
    >
      <div className="snackbar__content">
        <Icon variant="mark" /> {snackbarTitle}
      </div>
    </Snackbar>
  );
};
